module.exports = __webpack_public_path__ + "static/SyAStand-b8ec055db2e5e3ff9616cb6da811cb84.png";